import {combine, guard, merge, sample} from 'effector';

import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {billingAccess$} from 'models/profile/billing/access';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    BillingInvoicesGate,
    billingList$,
    defaultFilters,
    defaultSortings,
    filters$,
    filtersChanged,
    filtersReset,
    loadBillingInvoicesDataFx,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    changeInvoiceStatusFx,
    setInvoiceStatusChangeModalHandler,
    searchByIdChanged,
    searchByTinChanged,
    searchByIrnChanged,
    searchById$,
    searchByTin$,
    searchByIrn$,
    downloadInvoiceFx,
} from './index';

billingList$
    .on(loadBillingInvoicesDataFx.done, (current, {result}) =>
        BillingInvoicesGate.status.getState() && billingAccess$.getState().canViewInvoices
            ? result
            : current,
    )
    .reset([BillingInvoicesGate.close, billingAccess$]);

pageNumber$.reset(
    filtersChanged,
    sortingsChanged,
    stateReset,
    searchByIdChanged,
    searchByTinChanged,
    searchByIrnChanged,
);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: guard({
        clock: merge([
            changeInvoiceStatusFx.done,
            BillingInvoicesGate.open,
            billingAccess$.updates,
            pageNumberChanged,
            pageSizeChanged,
            tableStateChanged,
            searchByIdChanged,
            searchByTinChanged,
            searchByIrnChanged,
        ]),
        source: combine({
            sortings: sortings$,
            pageNumber: pageNumber$,
            pageSize: pageSize$,
            filters: filters$,
            searchById: searchById$,
            searchByTin: searchByTin$,
            searchByIrn: searchByIrn$,
            access: billingAccess$,
            active: BillingInvoicesGate.status,
        }),
        filter: ({access, active}) => active && access.canViewInvoices,
    }),
    fn: ({pageNumber, pageSize, filters, sortings, searchById, searchByTin, searchByIrn}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        searchById,
        searchByTin,
        searchByIrn,
    }),
    target: loadBillingInvoicesDataFx,
});

loadBillingInvoicesDataFx.failData.watch((err) => showRestError(err as RestError));
changeInvoiceStatusFx.failData.watch((err) => showRestError(err as RestError));
changeInvoiceStatusFx.done.watch(() => {
    toast.success(i18next.t('pages.profile.billing.invoiceStatusChange.success'));
    setInvoiceStatusChangeModalHandler({
        show: false,
        data: null,
    });
});

downloadInvoiceFx.failData.watch((err) => showRestError(err as RestError));
